// Truncate links in "In This Article" section and add "See More/Less" toggle
// <ul class="in-this-article__links js-truncate-links" [data-default-items="3" data-more-text="See More" data-less-text="See Less"]><li>Links</li></ul>

(function ($) {
  let linkContainers = document.querySelectorAll('.js-truncate-links');

  if (!linkContainers || linkContainers.length === 0) {
    return;
  }

  linkContainers.forEach(function(linkContainer) {
    let defaultItems = parseInt(linkContainer.getAttribute('data-default-items')) || 3;
    let seeMoreText = linkContainer.getAttribute('data-more-text') || '+ See More';
    let seeLessText = linkContainer.getAttribute('data-less-text') || '- See Less';
    let items = linkContainer.querySelectorAll('li');

    if (items.length > defaultItems) {
      for (let i = defaultItems; i < items.length; i++) {
        items[i].style.display = 'none';
      }

      let toggleLink = document.createElement('li');
      toggleLink.innerHTML = `<a href="#" class="see-more-link">${seeMoreText}</a>`;
      linkContainer.appendChild(toggleLink);

      let toggleAnchor = toggleLink.querySelector('a');
      toggleAnchor.addEventListener('click', function(e) {
        e.preventDefault();
        let isExpanded = this.classList.contains('expanded');
        if (isExpanded) {
          for (let i = defaultItems; i < items.length; i++) {
            items[i].style.display = 'none';
          }
          this.textContent = seeMoreText;
          this.classList.remove('expanded');
        } else {
          for (let i = defaultItems; i < items.length; i++) {
            items[i].style.display = '';
          }
          this.textContent = seeLessText;
          this.classList.add('expanded');
        }
      });
    }
  });
}(jQuery));
